export default {
  // TIMESHEET
  TIMESHEET_V2_ENABLED: 'timesheet:v2-enabled',
  TIMESHEET_HISTORY_DIALOG_OPEN: 'timesheet:history-dialog-open',
};
